<template>
  <div>
    <CRow>
      <CCol sm="12">
        <ProductsTable
          :items="products"
          hover
          striped
          border
          small
          fixed
          caption="Productos"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ProductsTable from '../components/products/ProductsTable.vue'
import ws from '../services/products';
import store from '../store'

export default {
  name: 'Products',
  components: { ProductsTable },
  data: function () {
		return {
            products: [],
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.products = response.data;
    }
    this.loaded();
  },
  methods: {
    async refreshItems (){
      this.loading();
      let response = await ws.get();

      if(response.type == "success"){
        this.products = response.data;
      }
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
